var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-app',{attrs:{"id":"app"}},[_c('v-main',{staticClass:"grey lighten-3 app-main"},[_c('v-row',{attrs:{"align":"start","justify":"center","no-gutters":""}},[_c('v-col',{attrs:{"cols":"12"}},[_c('router-view')],1)],1)],1),_c('loading'),_c('sync-dialog'),_c('install-sheet-ios'),_c('confirm-dialog',{ref:"confirm"})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }